$(document).ready(function () {
    var waitForEl = function (selector, callback) {
        if (jQuery(selector).length) {
            callback();
        } else {
            setTimeout(function () {
                waitForEl(selector, callback);
            }, 100);
        }
    };

    waitForEl('.template-index .oke-reviewCarousel-header .oke-reviewCarousel-header-title', function () {
        var $header = jQuery('.template-index .oke-reviewCarousel-header .oke-reviewCarousel-header-title');

        // Prevent duplicate insertion
        if (!$header.prev('.eq-testimonial-heading').length) {
            $header.before(`
                <p class="eq-testimonial-heading">
                    <svg height="18" viewBox="0 0 76.11111111111111 14" aria-hidden="true" role="none" style="
                    --oke-stars-foregroundColor: #F7BA06;
                    --oke-stars-backgroundColor: #E5E5E5;
                    --oke-stars-borderWidth: 1;
                    --oke-stars-borderColor: #2C3E50;
                    ">
                    <use x="0" href="#oke-star-filled"></use>
                    <use x="15.377777777777776" href="#oke-star-filled"></use>
                    <use x="30.755555555555553" href="#oke-star-filled"></use>
                    <use x="46.133333333333326" href="#oke-star-filled"></use>
                    <use x="61.511111111111106" href="#oke-star-filled"></use>
                    </svg><span>REAL WOMEN. REAL MOMENTS.</span>
                </p>
                `);
        }
    });
    // waitForEl('.template-index .oke-reviewCarousel-header .oke-minimalBadge-stars', function () {
    //     if (!jQuery('.template-index .eq-testimonial-description').length) {
    //         jQuery('.template-index .oke-reviewCarousel-header .oke-minimalBadge-stars').after(`
    //             <p class="eq-testimonial-description">
    //                 Est. 2015 · Trusted by 100,000+ Women · Rated 4.9 out of 5 by
    //             </p>
    //             `);
    //             const $reviewText = jQuery('.oke-ratingsBadge--minimal .oke-minimalBadge-count span');
    //             if ($reviewText.length) {
    //                 $reviewText.text('Verified Reviews');
    //             }
    //     }
    // });

    waitForEl('.template-index .oke-reviewCarousel-header .oke-minimalBadge-stars', function () {
    if (!jQuery('.template-index .eq-testimonial-description').length) {

        // Grab the review count from the native Okendo badge (e.g. "1,125")
        const $countEl = jQuery('.template-index .oke-ratingsBadge--minimal .oke-minimalBadge-count');
        const countMatch = $countEl.text().match(/[\d,]+/);
        const reviewCount = countMatch ? countMatch[0] : '';

        // Insert everything as one single line/paragraph
        jQuery('.template-index .oke-reviewCarousel-header .oke-minimalBadge-stars').after(`
            <p class="eq-testimonial-description">
                Rated 4.9★ across ${reviewCount} Verified Reviews </br> see what our customers are saying.
            </p>
        `);

        // Hide the original count badge so it doesn't show up as a separate/duplicate line
        $countEl.hide();
    }
});
    /***********************************************/
    /**************** Navigation Menu *************/
    /*********************************************/
    let BREAKPOINT = 992;
    const $body = $("body");
    const $menu = $("#mobile-menu");
    const $nav = $(".nav");

    let panelStack = [];

    // ==========================
    // OPEN MENU
    // ==========================
    $(".js-open-menu").on("click", function (e) {
        e.preventDefault();
        $menu.addClass("active");
        $body.addClass("menu-open overflow-hidden");
        $(".menu-toggle").addClass("open");
        checkHeaderOffset();
    });

    // ==========================
    // CLOSE MENU
    // ==========================
    function closeMenu() {
        $menu.removeClass("active");
        $body.removeClass("menu-open overflow-hidden");
        $(".menu-toggle").removeClass("open");
        $(".mega-menu").removeClass("active prev");
        collapseAccordionItem($menu.find("li.is-open"), false);
        panelStack = [];
    }

    $(".js-close-menu").on("click", closeMenu);

    // ==========================
    // ESC CLOSE
    // ==========================
    $(document).on("keyup", function (e) {
        if (e.key === "Escape") closeMenu();
    });

    // ==========================
    // OUTSIDE CLICK
    // ==========================
    $(document).on("click", function (e) {
        if ($body.hasClass("menu-open")) {
            if (!$(e.target).closest("#mobile-menu, .menu-toggle").length) {
                closeMenu();
            }
        }
    });

    // ==========================
    // MULTI LEVEL PANEL
    // ==========================
    $(".has-mega > a").on("click", function (e) {
        if ($(window).width() < BREAKPOINT) {
            e.preventDefault();
            const $current = $(this).closest(".mega-menu");
            const $next = $(this).siblings(".mega-menu");
            if (!$next.length) return;
            if ($current.length) {
                $current.addClass("prev");
                panelStack.push($current);
            }
            $next.addClass("active");
        }
    });

    // ==========================
    // DESKTOP HOVER
    // ========================== 

    $(".category-title").on("mouseenter", function () {
        if (!window.matchMedia("(min-width: 992px)").matches) return;
        const target = $(this).data("target");
        if (!target) return;
        $(".category-title").removeClass("active");
        $(this).addClass("active");
        $(".mega-panel").removeClass("active");
        $("#" + target).addClass("active");
    });

    $(document).ready(function () {
        if (window.matchMedia("(min-width: 992px)").matches) {
            const $default = $('.category-title[data-target="best"]');
            $default.addClass("active");
            $(".mega-panel").removeClass("active");
            $("#best").addClass("active");
        }
    });

    // ==========================
    // HEADER OFFSET (FINAL FIX)
    // ==========================
    function checkHeaderOffset() {
        const header = document.querySelector(".header");
        const announcement = document.querySelector(".announcement-bar");
        let headerHeight = header ? header.offsetHeight : 0;
        let announcementHeight = 0;
        if (announcement) {
            const rect = announcement.getBoundingClientRect();
            // ONLY include if visible in viewport
            if (rect.bottom > 0) {
                announcementHeight = rect.height;
            }
        }
        const total = headerHeight + announcementHeight;
        document.documentElement.style.setProperty("--header-offset", total + "px");
        document.documentElement.style.setProperty("--header-height", headerHeight + "px");
        document.documentElement.style.setProperty("--announcement-height", announcementHeight + "px");
    }
    // Run only when needed (NOT on scroll)
    $(window).on("load resize scroll", checkHeaderOffset);

    // ==========================
    // Mobile submenu accordion (one open per level)
    // ==========================
    function collapseAccordionItem($items, animate) {
        // Close the items and anything open inside them
        const $all = $items.add($items.find("li.is-open"));
        $all.removeClass("is-open");
        $all.find("> div > [data-mobile-accordion-toggle]").attr("aria-expanded", "false");
        $all.children("ul").each(function () {
            if (animate) {
                $(this).stop(true, true).slideUp(300);
            } else {
                $(this).stop(true, true).hide();
            }
        });
    }

    $(document).on("click", "[data-mobile-accordion-toggle]", function (e) {
        if (window.matchMedia("(min-width: 992px)").matches) return;

        e.preventDefault();
        e.stopPropagation();

        const $item = $(this).closest("li");
        const $list = $item.children("ul");
        if (!$list.length) return;

        if ($item.hasClass("is-open")) {
            collapseAccordionItem($item, true);
            return;
        }

        collapseAccordionItem($item.siblings(".is-open"), true);
        $item.addClass("is-open");
        $(this).attr("aria-expanded", "true");
        $list.stop(true, true).slideDown(300);
    });

    $(".shop-megamenu, .mega-menu").hover(
        function () {
            $("body").addClass("is-megamenu-open");
        },
        function () {
            $("body").removeClass("is-megamenu-open");
        }
    );
    /******************************************/
    /**************** Move to top *************/
    /******************************************/
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 100) {
            $('.scroll-top').addClass('visible');
        } else {
            $('.scroll-top').removeClass('visible');
        }
    });
    $(".scroll-top").on("click", function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
    });

    /********************************************/
    /**************** Banner Slider ************/
    /*******************************************/
    const $heroWrapper = $(".heroBannerSwiper");

    if ($heroWrapper.length) {
        const progressBar = document.querySelector(".hero-progress__fill");

        // Pull customizer settings from data-* attributes rendered by the section
        const heroAutoplayEnabled = $heroWrapper.data("autoplay") === true || $heroWrapper.data("autoplay") === "true";
        const heroAutoplaySpeed = parseInt($heroWrapper.data("autoplay-speed"), 10) || 8000;

        const heroSwiperConfig = {
            loop: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            speed: 1500,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: false,
                },
                768: {
                    slidesPerView: 1,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 1,
                    centeredSlides: true,
                },
            }
        };

        if (heroAutoplayEnabled) {
            heroSwiperConfig.autoplay = {
                delay: heroAutoplaySpeed,
                disableOnInteraction: false,
            };
        }

        const heroSwiper = new Swiper(".heroBannerSwiper", heroSwiperConfig);

        // Progress bar is optional — only wire it up if the merchant enabled it in the customizer
        if (progressBar && heroAutoplayEnabled) {
            heroSwiper.on("slideChangeTransitionStart", function () {
                progressBar.style.transition = "none";
                progressBar.style.width = "0%";
                requestAnimationFrame(() => {
                    progressBar.style.transition = "";
                });
            });
            heroSwiper.on("autoplayTimeLeft", function (swiper, time, progress) {
                progressBar.style.width = ((1 - progress) * 100) + "%";
            });
        }
    }

    /*****************************************/
    /**************** announcement-bar *************/
    /****************************************/
    const $announcementWrapper = $(".announcement-bar__wrapper");

    if ($announcementWrapper.length) {
        const announcementAutoplayEnabled = $announcementWrapper.data("autoplay") === true || $announcementWrapper.data("autoplay") === "true";
        const announcementLoopEnabled = $announcementWrapper.data("loop") === true || $announcementWrapper.data("loop") === "true";
        const announcementSpeed = parseInt($announcementWrapper.data("speed"), 10) || 2500;

        const announcementSwiperConfig = {
            loop: announcementLoopEnabled,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 600,
            direction: 'vertical',
        };

        if (announcementAutoplayEnabled) {
            announcementSwiperConfig.autoplay = {
                delay: announcementSpeed,
                disableOnInteraction: false,
            };
        }

        var announcementSwiper = new Swiper('.announcement-bar__wrapper', announcementSwiperConfig);
    }



    /*****************************************/
    /**************** MINI CART *************/
    /****************************************/
    $(".cart-btn").on("click", function (e) {
        e.preventDefault();
        $(".mini_cart").css("display", "flex").show();
        if ($(".mini_cart").length) {
            $(".mini_cart")[0].offsetHeight; // force reflow
        }
        $("body").addClass("cart_open");
    });

    $(document).on("click", ".cart-close", function () {
        $("body").removeClass("cart_open");
        setTimeout(function () {
            if (!$("body").hasClass("cart_open")) {
                $(".mini_cart").hide();
            }
        }, 500);
    });
    /* ===== GLOBAL OUTSIDE CLICK ===== */
    $(document).on("click touchend", function (e) {
        if ($(e.target).closest(".mini_cart, .cart-btn, [data-add-to-cart]").length === 0) {
            $("body").removeClass("cart_open");
            setTimeout(function () {
                if (!$("body").hasClass("cart_open")) {
                    $(".mini_cart").hide();
                }
            }, 500);
        }
    });
    /********************************************/
    /**************** New Arrival Slider ************/
    /*******************************************/
    (function ($) {

        var BREAKPOINT = 991;
        var sliderSelector = '.product-slider';
        var swiperInstance = null;

        function shouldUseSwiper() {
            return $(window).width() < BREAKPOINT;
        }

        function initSwiper() {
            if (swiperInstance) return;

            if (!$(sliderSelector).length) return;

            swiperInstance = new Swiper(sliderSelector, {
                slidesPerView: 1.1,
                spaceBetween: 5,
                watchOverflow: true,
                grabCursor: true,
                breakpoints: {
                    575: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                    },
                    640: {
                        slidesPerView: 2.1,
                        spaceBetween: 5,
                    },
                },
            });
        }

        function destroySwiper() {
            if (!swiperInstance) return;

            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }

        function handleViewportChange() {
            if (shouldUseSwiper()) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }

        var resizeTimeout;

        $(document).ready(function () {
            handleViewportChange();

            $(window).on('resize', function () {
                clearTimeout(resizeTimeout);

                resizeTimeout = setTimeout(function () {
                    handleViewportChange();
                }, 150);
            });
        });

    })(jQuery);

    /********************************************/
    /**************** Notable Wears  Carousel ************/
    /*******************************************/
    if ($('.celebrity-slider__swiper').length) {
        new Swiper('.celebrity-slider__swiper', {
            slidesPerView: 1.1,
            spaceBetween: 5,
            grabCursor: true,
            watchOverflow: true,
            pagination: {
                el: '.celebrity-swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.celebrity-slider__arrow--next',
                prevEl: '.celebrity-slider__arrow--prev',
            },
            breakpoints: {
                575: {
                    slidesPerView: 1,
                    spaceBetween: 5,
                },
                640: {
                    slidesPerView: 2.1,
                    spaceBetween: 5,
                },
                991: {
                    slidesPerView: 4.1,
                    spaceBetween: 5,
                },
            },
        });
    }

    /********************************************/
    /**************** Shop The Highlights Carousel ************/
    /*******************************************/
    (function () {
        const BREAKPOINT = 991;
        const sliderSelector = '.highlight-slider';
        let swiper = null;

        function initSwiper() {
            const slider = document.querySelector(sliderSelector);

            if (!slider || swiper) return;

            swiper = new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 5,
                watchOverflow: true,
                grabCursor: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                updateOnWindowResize: true,
                pagination: {
                    el: '.highlight-swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    575: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                    },
                    640: {
                        slidesPerView: 2.1,
                        spaceBetween: 5,
                    },
                },
            });
        }

        function destroySwiper() {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }

        function checkSlider() {
            if (window.innerWidth <= BREAKPOINT) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }

        window.addEventListener('load', checkSlider);
        window.addEventListener('resize', function () {
            clearTimeout(window.sliderResizeTimer);
            window.sliderResizeTimer = setTimeout(checkSlider, 200);
        });
    })();

    /********************************************/
    /**************** In-house Category Carousel ************/
    /*******************************************/
    (function ($) {
        const BREAKPOINT = 991;
        let inhouseSwiper = null;
        function initSwiper() {
            if (inhouseSwiper) return;
            inhouseSwiper = new Swiper('#inhouseSwiper', {
                slidesPerView: 1.1,
                spaceBetween: 5,
                watchOverflow: true,
                grabCursor: true,
                pagination: {
                    el: '.inhouse-swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    575: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                    },
                    640: {
                        slidesPerView: 2.1,
                        spaceBetween: 5,
                    },
                },
            });
        }
        function destroySwiper() {
            if (!inhouseSwiper) return;
            inhouseSwiper.destroy(true, true);
            inhouseSwiper = null;
        }
        function checkSlider() {
            if (window.innerWidth < BREAKPOINT) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }
        $(window).on('load resize', checkSlider);
    })(jQuery);

    /********************************************/
    /**************** Services Carousel ************/
    /*******************************************/
    (function () {
        const BREAKPOINT = 767;
        let swiper = null;
        function initSwiper() {
            if (swiper) return;
            new Swiper('.service-wrapper', {
                slidesPerView: 1,
                loop: true,
                speed: 1000,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.service-swiper-pagination',
                    clickable: true
                }
            });
        }
        function destroySwiper() {
            if (!swiper) return;
            swiper.destroy(true, true);
            swiper = null;
        }
        function toggleSwiper() {
            if (window.innerWidth <= BREAKPOINT) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }
        window.addEventListener('load', toggleSwiper);
        window.addEventListener('resize', () => {
            clearTimeout(window.serviceResizeTimer);
            window.serviceResizeTimer = setTimeout(toggleSwiper, 200);
        });
    })();

    // ==========================================
    // Product Swatches Change (New Arrivals)
    // ==========================================
    $(document).on("click", ".product-card__swatch", function (e) {
        e.preventDefault();
        const $swatch = $(this);
        const $card = $swatch.closest(".product-card");

        $card.find(".product-card__swatch").removeClass("product-card__swatch--active");
        $swatch.addClass("product-card__swatch--active");

        const variantId = $swatch.attr("data-variant-id");
        const variantImage = $swatch.attr("data-variant-image");
        const variantPrice = $swatch.attr("data-variant-price");
        const variantAvailable = $swatch.attr("data-variant-available") === "true";

        if (variantImage) {
            $card.find(".product-card__image").attr("src", variantImage);
        }

        if (variantPrice) {
            $card.find(".product-card__price").html(variantPrice);
        }

        // Update both the hidden form input and the button's data attribute
        $card.find('input[name="id"]').val(variantId);

        const $addBtn = $card.find("[data-add-to-cart]");
        if ($addBtn.length) {
            $addBtn.attr("data-variant-id", variantId);
            if (variantAvailable) {
                $addBtn.removeAttr("disabled").text("Add to Bag");
            } else {
                $addBtn.attr("disabled", "disabled").text("Sold Out");
            }
        }
    });

    // ==========================================
    // Listen to Native Add to Cart Success
    // ==========================================
    $(document).on("theme:cart:added", function () {
        refreshMiniCart().then(function () {
            $(".mini_cart").css("display", "flex").show();
            if ($(".mini_cart").length) {
                $(".mini_cart")[0].offsetHeight; // force reflow
            }
            $("body").addClass("cart_open");
        });
    });

    // ==========================================
    // Mini Cart Quantity Adjustment & Item Removal
    // ==========================================
    $(document).on("click", ".mini_cart .js-qty-adjust", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const action = $btn.attr("data-action");
        const itemKey = $btn.attr("data-line-item-key");
        const $input = $btn.siblings(".js-qty-input");
        let currentQty = parseInt($input.val()) || 1;

        let newQty = action === "plus" ? currentQty + 1 : currentQty - 1;
        if (newQty < 1) {
            newQty = 0;
        }

        const $item = $btn.closest(".mini_cart_item");
        $item.css("opacity", "0.5");

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: itemKey,
                quantity: newQty
            },
            dataType: "json",
            success: function () {
                refreshMiniCart();
            },
            error: function (xhr, status, error) {
                console.error("Failed to update cart quantity:", xhr.responseJSON || error);
                $item.css("opacity", "1");
            }
        });
    });

    $(document).on("click", ".mini_cart .js-remove-cart-item", function (e) {
        e.preventDefault();
        const $btn = $(this);
        const itemKey = $btn.attr("data-line-item-key");

        const $item = $btn.closest(".mini_cart_item");
        $item.css("opacity", "0.5");

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: itemKey,
                quantity: 0
            },
            dataType: "json",
            success: function () {
                refreshMiniCart();
            },
            error: function (xhr, status, error) {
                console.error("Failed to remove item from cart:", xhr.responseJSON || error);
                $item.css("opacity", "1");
            }
        });
    });

    // ==========================================
    // Refresh Mini Cart via Section Rendering API
    // ==========================================
    function refreshMiniCart() {
        const sectionElement = document.querySelector('.header-main-wrapper');
        let sectionId = 'eq-header';
        if (sectionElement && sectionElement.id) {
            sectionId = sectionElement.id.replace('shopify-section-', '');
        }

        return fetch(`/?sections=${sectionId}`)
            .then(function (response) {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then(function (data) {
                const htmlString = data[sectionId];
                if (htmlString) {
                    updateMiniCartDom(htmlString);
                }
            })
            .catch(function (err) {
                console.warn("Failed to fetch via sections API, falling back to section_id", err);
                return fetch(`/?section_id=${sectionId}`)
                    .then(function (response) { return response.text(); })
                    .then(function (htmlString) {
                        if (htmlString) {
                            updateMiniCartDom(htmlString);
                        }
                    });
            });
    }

    function updateMiniCartDom(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const newMiniCart = doc.querySelector('.mini_cart');
        const currentMiniCart = document.querySelector('.mini_cart');
        if (newMiniCart && currentMiniCart) {
            currentMiniCart.innerHTML = newMiniCart.innerHTML;
        }

        const newCartCount = doc.querySelector('.cart-item-count');
        const currentCartCount = document.querySelector('.cart-item-count');

        if (newCartCount) {
            if (currentCartCount) {
                currentCartCount.innerHTML = newCartCount.innerHTML;
                currentCartCount.classList.remove('hidden');
            } else {
                const cartBtn = document.querySelector('.cart-btn');
                if (cartBtn) {
                    const badge = document.createElement('span');
                    badge.className = 'cart-item-count';
                    badge.innerHTML = newCartCount.innerHTML;
                    cartBtn.appendChild(badge);
                }
            }
        } else if (currentCartCount) {
            currentCartCount.remove();
        }
    }

    // ==========================================
    // Handle Native Cart Add Events
    // ==========================================
    $(document).on("theme:cart:add", function (e) {
        const detail = (e.originalEvent && e.originalEvent.detail) || e.detail;
        const clickedElement = detail?.button;
        const isButtonATC = clickedElement?.matches('[data-add-to-cart]');
        const getButtonATC = clickedElement?.closest('[data-add-to-cart]');
        const button = isButtonATC ? clickedElement : getButtonATC;
        if (!button) return;

        if (button.matches('.product-upsell__btn')) return;

        const $btn = $(button);
        const $form = $btn.closest("form");
        if (!$form.length) return;

        e.preventDefault();

        $btn.addClass("is-loading").attr("disabled", "disabled");
        const $btnText = $btn.find("[data-add-to-cart-text]");
        const originalText = $btnText.length ? $btnText.text() : $btn.text();

        if ($btnText.length) {
            $btnText.text("Adding...");
        } else {
            $btn.text("Adding...");
        }

        const formData = new FormData($form[0]);

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (item) {
                document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
                $btn.removeClass("is-loading").removeAttr("disabled");
                if ($btnText.length) {
                    $btnText.text(originalText);
                } else {
                    $btn.text(originalText);
                }
            },
            error: function (xhr, status, error) {
                console.error("AJAX add to cart failed:", xhr.responseJSON || error);
                alert("Failed to add item to cart. Please try again.");
                $btn.removeClass("is-loading").removeAttr("disabled");
                if ($btnText.length) {
                    $btnText.text(originalText);
                } else {
                    $btn.text(originalText);
                }
            }
        });
    });

});


/***********************************************/
/******* FourSixty Carousel Mobile DOTS *******/
/*********************************************/
window.addEventListener("load", function () {

    if (window.innerWidth > 991) return;

    setTimeout(() => {

        const slider = document.querySelector(".fs-slider-container");
        if (!slider) return;

        const nextBtn = slider.querySelector(".fs-slider-next-button");
        const prevBtn = slider.querySelector(".fs-slider-prev-button");
        const slides = slider.querySelectorAll(".fs-entry-container");

        if (!nextBtn || !slides.length) return;

        const totalPages = Math.ceil(slides.length / 2);
        let current = 0;

        const dotsWrap = document.createElement("div");
        dotsWrap.className = "fs-slider-dots";

        function updateDots() {
            dotsWrap.querySelectorAll(".fs-slider-dot").forEach((dot, i) => {
                dot.classList.toggle("active", i === current);
            });
        }

        // Create Dots
        for (let i = 0; i < totalPages; i++) {

            const dot = document.createElement("span");
            dot.className = "fs-slider-dot";

            if (i === 0) {
                dot.classList.add("active");
            }

            dot.addEventListener("click", () => {

                const diff = i - current;

                if (diff > 0) {
                    for (let j = 0; j < diff; j++) {
                        nextBtn.click();
                    }
                } else {
                    for (let j = 0; j < Math.abs(diff); j++) {
                        prevBtn.click();
                    }
                }

                current = i;
                updateDots();

            });

            dotsWrap.appendChild(dot);

        }

        slider.appendChild(dotsWrap);

        // Arrow Click
        nextBtn.addEventListener("click", () => {
            current = (current + 1) % totalPages;
            updateDots();
        });

        prevBtn.addEventListener("click", () => {
            current = (current - 1 + totalPages) % totalPages;
            updateDots();
        });

        // Touch Swipe
        let touchStartX = 0;

        slider.addEventListener("touchstart", (e) => {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });

        slider.addEventListener("touchend", (e) => {

            const touchEndX = e.changedTouches[0].clientX;
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) < 40) return;

            if (diff > 0) {
                // Swipe Left
                current = (current + 1) % totalPages;
            } else {
                // Swipe Right
                current = (current - 1 + totalPages) % totalPages;
            }

            updateDots();

        }, { passive: true });

    }, 1500);

});